export default __webpack_public_path__ + "static/media/arrow-right.c28b5e9c.svg";